<template>
  <div id="Awards">
		<h1>Ödüller</h1>
		<div id="award-wrapper">
			<div 
				v-for="(award, index) in awards"
				:key="index" 
				class="award-item-wrapper"
				@mouseover="award.detailsVisible=true"
				@mouseleave="award.detailsVisible=false"
			>
				<h2>{{award.title}}</h2>
				<img :src="require('../../public/icons/Award.svg')">
				
				<div class="detail" v-if="award.detailsVisible">
					<span class="tag" v-if="award.kind">{{award.kind}}</span>
					<span class="tag" v-if="award.year">{{award.year}}</span>
					<span class="tag" v-if="award.place">{{award.place}}</span>
					<span class="tag" v-if="award.nationality">{{award.nationality}}</span>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
  const firebase = require('firebase/app');

  export default {
    name: 'Awards',
    data() {
      return {
        isVisible: true,
        awards: [],
      }
    },

    created(){
			firebase.database().ref('/AwardsItem').once('value').then((snapshot) => {
				this.awards = snapshot.val(); 
			});
    },
  }
</script>

<style lang="scss" scoped>
	h1{
		display: inline-block;
		color: goldenrod;
		text-shadow: 0 3px 5px #c98e19;
		font-size: xx-large;
		text-align: center;
		width: 100%;
	}

	#award-wrapper{
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		width: 90%;
		margin-left: auto;
		margin-right: auto;

		@media screen and (max-width: 768px){
			grid-template-columns: 1fr;
		}

		.award-item-wrapper{
			display: flex;
			flex-direction: column;
			transition: all .5s;

			transform: scale3d(1, 1, 1);

			&:nth-child(n){
				 grid-column: 1 / span 1;
			}

			&:nth-child(2n){
				grid-column: 2 / span 1;
			}

			h2{
				display: inline-block;
				text-align: center;
				width: fit-content;
				margin: 10px auto;

				font-size: .7em;
				font-weight: bold;
				color: goldenrod;
			}

			img{
				width: 20vw;
				margin-left: auto;
				margin-right: auto;

				justify-content: center;
			}

			@media screen and (max-width: 1024px){
				h2{
					font-size: .5em;
					transition: all .5s;
				}

				img{
					width: 18vw;
					transition: all .5s;
				}
			}

			@media screen and (max-width: 768px){
				&:nth-child(n){
					grid-column: 1;
				}

				&:nth-child(2n){
					grid-column: 1;
				}

				h2{
					font-size: .8em;
					transition: all .5s;
				}

				img{
					width: 30vw;
					transition: all .5s;
				}
			}

			@media screen and (max-width: 425px){
				h2{
					font-size: .6em;
					transition: all .5s;
				}

				img{
					width: 50vw;
					transition: all .5s;
				}
			}

			&:hover{
				cursor: pointer;
				transition: all .5s;
				transform: scale3d(1.1, 1.1, 1.1);

				.detail{
					width: 60%;
					margin-left: auto;
					margin-right: auto;
					margin-bottom: 1em;

					.tag{
						background-color: #ee9b00;
						color: white;
						filter: drop-shadow(0 3px 5px #333333a6);
						padding: 10px;
						border-radius: 10em;
						font-size: .4em;
						display: inline-block;
						position: relative;
						margin: 5px 2px;
					}
				}
			}
		}
	}
</style>